import history from './history'
import { ENVIRONMENTS, PUBLIC_ROUTES } from '../lib/constants'
import { get } from 'lodash'

export const isEnvironmentDev = () => window.location.origin.match(/dev/i)
export const isEnvironmentTest = () => {
  return window.location.origin.match(/test/i) || process.env.REACT_APP_API_URL?.includes('test')
}
export const isEnvironmentStage = () => {
  return window.location.origin.match(/stage/i) || process.env.REACT_APP_API_URL?.includes('stage')
}
export const isEnvironmentProd = () => window.location.origin.match(/suki\.ai/i)

let environment
let oktaClientId
let oktaAltaisSSOClientId
let oktaAltaisSSOClientIdv2
let launchDarklyClientId
let redirect_uri = window.location.origin + '/implicit/callback'

const PROD_OKTA_URL = 'https://suki-api.okta.com'
const PROD_OKTA_OAUTH = 'https://suki-api.okta.com/oauth2/default'

const SANDBOX_OKTA_URL = 'https://suki-sandbox.oktapreview.com'
const SANDBOX_OKTA_OAUTH = 'https://suki-sandbox.oktapreview.com/oauth2/default'

if (isEnvironmentDev()) {
  environment = ENVIRONMENTS.DEV
} else if (isEnvironmentTest()) {
  environment = ENVIRONMENTS.TEST
} else if (isEnvironmentStage()) {
  environment = ENVIRONMENTS.STAGE
} else if (isEnvironmentProd()) {
  environment = ENVIRONMENTS.PROD
} else {
  environment = ENVIRONMENTS.LOCAL
}

// URL for Okta Sandbox Apps
// https://suki-sandbox-admin.oktapreview.com/admin/app/oidc_client/client/0oanh5ksoyJoJT03o0h7#tab-general

switch (environment) {
  case ENVIRONMENTS.TEST:
    oktaClientId = '0oanr3o0oCl1Pt10N296'
    oktaAltaisSSOClientId = '0oa5j9w6zya7CQNbG297'
    oktaAltaisSSOClientIdv2 = '0oa8rlob6uCd1rLOa297'
    launchDarklyClientId = '5c894bb1b2fd181de341133c'
    redirect_uri = 'https://app.suki-test.com/implicit/callback'
    break
  case ENVIRONMENTS.STAGE:
    oktaClientId = '0oao631r02pkumbg9296'
    oktaAltaisSSOClientId = '0oa5j9w6zya7CQNbG297'
    oktaAltaisSSOClientIdv2 = '0oa8un612zX8cFy5I297'
    launchDarklyClientId = '5c8b67597c606f07a079aa45'
    redirect_uri = 'https://app.suki-stage.com/implicit/callback'
    break
  case ENVIRONMENTS.PROD:
    oktaClientId = '0oao6vviukKraQDa1296'
    launchDarklyClientId = '5c894bb1b2fd181de341133d'
    oktaAltaisSSOClientIdv2 = '0oa8vrn1bccxW4KAr297'
    break
  case ENVIRONMENTS.DEV:
    oktaClientId = '0oanh5ksoyJoJT03o0h7'
    oktaAltaisSSOClientId = '0oaumc3b86V6cGGB80h7'
    oktaAltaisSSOClientIdv2 = '0oaz5k5i5mEVWS7El0h7'
    launchDarklyClientId = '5c8b6780ea9a91079dbb40fc'
    break
  case ENVIRONMENTS.LOCAL:
  default:
    oktaClientId = '0oanh5ksoyJoJT03o0h7'
    oktaAltaisSSOClientId = '0oaumc3b86V6cGGB80h7'
    oktaAltaisSSOClientIdv2 = '0oaz5k5i5mEVWS7El0h7'
    launchDarklyClientId = '5c8b6780ea9a91079dbb40fc'
    break
}

export const OktaConfig = {
  // the auth config data used to initialize the okta Auth object
  auth: {
    issuer: isEnvironmentProd() || isEnvironmentStage() || isEnvironmentTest() ? PROD_OKTA_OAUTH : SANDBOX_OKTA_OAUTH,
    redirect_uri,
    // We are supporting only dev and qa, until we figure out what to do for stage environment next week
    client_id: oktaClientId,
    altais_client_id: oktaAltaisSSOClientId,
    altais_client_id_v2: oktaAltaisSSOClientIdv2,
    pkce: false,
    onAuthRequired: () => {
      const search = get(history, 'location.search', '')
      if (!search.includes('code')) {
        const path = history?.location?.pathname
        // if path not in public routes list
        if (!PUBLIC_ROUTES.includes(path)) {
          history.push('/')
        }
      }
    }
  },
  baseURL: isEnvironmentProd() || isEnvironmentStage() || isEnvironmentTest() ? PROD_OKTA_URL : SANDBOX_OKTA_URL
}

// The launch darkly client id allows us to communicate with our LD admin account. There is
// a different ID for each environment
export const LDClientId = launchDarklyClientId
export const Environment = environment
export const isDev = environment === ENVIRONMENTS.LOCAL || environment === ENVIRONMENTS.DEV

export const History = history

export const Analytics = {
  trackingId: 'UA-100205469-2'
}

export const getIntercomID = () => {
  return isEnvironmentProd() ? 'mrausu9h' : 'tfrr9ikc'
}

export const BASE_URL = window.location.origin.includes('app') ? window.location.origin.replace('app', 'api') : window.location.origin
